import { render, staticRenderFns } from "./ProprietaireView.vue?vue&type=template&id=13710446&"
import script from "./ProprietaireView.vue?vue&type=script&lang=js&"
export * from "./ProprietaireView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports